import React from "react";
import { Container } from "./style";
import Switch from "../../components/Switch";

export default () => {
    return (
        <Container>
            <Switch />
        </Container>
    );
};
